export default "__VITE_ASSET__6p_cOuOe__"